import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflows/{userWorkflowId}/notes';
type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/notes']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getUserWorkflowNotes = async ({ userWorkflowId, page, perPage }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { userWorkflowId });
  const response = await noodleApiClient.get(path, { params: { page, perPage } });

  return response.data;
};

export default getUserWorkflowNotes;
